import React, { useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import CustomInputComponent from "./CustomInput";
import { Button, Grid, IconButton } from "@mui/material";
import Divider from "@mui/material/Divider";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import PointCard from "../useCase/PointCard";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import {
  requestAddQuestionToUseCase,
  requestEditQuestion,
} from "../../redux/actions/useCaseActionCreators";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { translate } from "../../utils/utils";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import BrowseQuestion from "./BrowseQuestions";
import TranslationModal from "./TranslationModal";
import TranslateIcon from "@mui/icons-material/Translate";

function QuestionChoicesCard({
  index,
  questionData,
  handleDelete,
  isDisplayMode,
  isNewQuestion,
  threshold,
  duplicated,
}) {
  const { t } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");

  const [isEditMode, setIsEditMode] = useState(isNewQuestion);
  const [isCancelled, setIsCancelled] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [questionSeleted, setQuestionSelected] = useState(false);
  const [openTranslator, setOpenTranslator] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const validationSchema = Yup.object().shape({
    title: Yup.string(),
    title_fr: Yup.string(),
    // category: Yup.string(),
    // category_fr: Yup.string(),
    choices: Yup.array().of(
      Yup.object().shape({
        title:
          lang === "en"
            ? Yup.string().required(t("required_field"))
            : Yup.string(),
        title_fr:
          lang === "fr"
            ? Yup.string().required(t("required_field"))
            : Yup.string(),
        // category:
        //   lang === "en"
        //     ? Yup.string().required(t("required_field"))
        //     : Yup.string(),
        // category_fr:
        //   lang === "fr"
        //     ? Yup.string().required(t("required_field"))
        //     : Yup.string(),
        weight: Yup.number()
          .required(t("required"))
          .nullable()
          .min(1, `${t("number_control")} ${threshold}`)
          .max(threshold, `${t("number_control")} ${threshold}`),
      })
    ),
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handleQuestionSelected = () => {
    setQuestionSelected(true);
  };

  const handleCloseTranslator = () => {
    setOpenTranslator(false);
  };

  function addtitle(values, setValues) {
    // update dynamic form
    const choices = [...values.choices];
    choices.push({ title: "", weight: null });
    setValues({ ...values, choices });

    // call formik onChange method
    // field.onChange(e);
  }

  function deleteAnswer(index, values, setValues) {
    // update dynamic form
    const choices = [...values.choices];
    choices.splice(index, 1);
    setValues({ ...values, choices });

    // call formik onChange method
    // field.onChange(e);
  }

  function cancelQuestion(resetForm) {
    resetForm();

    !questionData.id ? setIsCancelled(true) : setIsEditMode(false);
  }
  function handleDeleteOnQuestion(id) {
    if (id) {
      handleDelete(id);
    } else {
      setIsCancelled(true);
    }
  }

  function onSubmit(fields) {
    if (fields.id) {
      dispatch(
        requestEditQuestion(
          fields.id,
          { uc_id: params.caseId, question: fields },
          params.caseId
        )
      );
    } else {
      if (fields.title_fr === "") {
        delete fields["title_fr"];
      } else if (fields.title === "") {
        delete fields["title"];
      }
      fields.choices.map((choice) => {
        if (choice.title_fr === "") {
          delete choice["title_fr"];
        } else if (choice.title === "") {
          delete choice["title"];
        }
      });
      if (fields.category_fr === "") {
        delete fields["category_fr"];
      } else if (fields.category === "") {
        delete fields["category"];
      }
      fields.choices.map((choice) => {
        if (choice.category_fr === "") {
          delete choice["category_fr"];
        } else if (choice.category === "") {
          delete choice["category"];
        }
      });

      dispatch(
        requestAddQuestionToUseCase({
          id_usecase: params.caseId,
          question: fields,
        })
      );
    }

    // display form field values on success
    setIsEditMode(false);
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(fields, null, 4));
  }

  const isMobile = useMediaQuery("(max-width:800px)");

  return (
    <div>
      <Grid container justifyContent="center" alignItems="center">
        {!isCancelled && (
          <Grid
            item
            xs={12}
            sx={{
              background: "#FFFFFF",
              border: "1px solid #DBE1DF",
              borderRadius: "10px",
            }}
          >
            <Formik
              enableReinitialize={true}
              initialValues={
                isNewQuestion
                  ? {
                      ...questionData,
                      choices: questionData?.choices?.map((el) => ({
                        id: el.id,
                        id_q: el.id_q,
                        title: el.title,
                        title_fr: el.title_fr,
                        category_fr: el.category_fr,
                        category: el.category,
                        weight: duplicated ? "" : el.weight,
                      })),
                    }
                  : questionData
              }
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                errors,
                values,
                touched,
                setValues,
                resetForm,
                setFieldValue,
              }) => (
                <Form>
                  <div>
                    <Grid container spacing={2} sx={{ padding: "20px" }}>
                      <Grid item xs={12}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontFamily: "Bebas Neue",
                            }}
                          >
                            Question {index + 1}
                          </span>
                          {isEditMode && !isDisplayMode && questionData?.id && (
                            <IconButton
                              sx={{ background: "#E3E5E5" }}
                              onClick={() => handleDelete(questionData.id)}
                            >
                              <DeleteForeverOutlinedIcon />
                            </IconButton>
                          )}
                          {!isEditMode && !isDisplayMode && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <IconButton
                                sx={{
                                  background: "#E3E5E5",
                                  marginRight: "10px",
                                }}
                                onClick={() => {
                                  setIsEditMode(true);
                                }}
                              >
                                <ModeEditOutlinedIcon />
                              </IconButton>
                              <IconButton
                                sx={{ background: "#E3E5E5" }}
                                onClick={() =>
                                  handleDeleteOnQuestion(questionData.id)
                                }
                              >
                                <DeleteForeverOutlinedIcon />
                              </IconButton>
                            </div>
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        {isEditMode && !isDisplayMode ? (
                          <>
                            {isMobile ? (
                              <Grid container spacing={1}>
                                <Grid item xs={12}>
                                  <Field
                                    placeholder={t("type_question")}
                                    msgError={errors.title}
                                    name={translate("title")}
                                    isError={touched.title && errors.title}
                                    render={(props) => (
                                      <CustomInputComponent
                                        {...props}
                                        questionSeleted={questionSeleted}
                                        cancelBrowseQuestion={
                                          setQuestionSelected
                                        }
                                        setFieldValue={setFieldValue}
                                        values={values}
                                        lang={lang}
                                      />
                                    )}
                                    type="text"
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <Button
                                    variant="contained"
                                    color="button"
                                    fullWidth
                                    sx={{ height: "40px" }}
                                    onClick={() => {
                                      setOpen(true);
                                    }}
                                  >
                                    <OpenInBrowserIcon />
                                    {t("browse_questions")}
                                  </Button>
                                </Grid>
                                {!questionSeleted && (
                                  <Grid item xs={12}>
                                    {showMore ? (
                                      <>
                                        <span
                                          style={{
                                            color: "#8D8482",
                                            fontSize: "9px",
                                          }}
                                        >
                                          {t("error_translation_usecases")}
                                        </span>
                                        &nbsp;
                                        <span
                                          style={{ fontSize: "9px" }}
                                          onClick={() => setShowMore(false)}
                                        >
                                          {t("see_less")}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span
                                          style={{
                                            color: "#8D8482",
                                            fontSize: "9px",
                                          }}
                                        >
                                          {t(
                                            "error_translation_usecases"
                                          ).substring(0, 65)}
                                          ...
                                        </span>
                                        &nbsp;
                                        <span
                                          style={{ fontSize: "9px" }}
                                          onClick={() => setShowMore(true)}
                                        >
                                          {t("see_more")}
                                        </span>
                                      </>
                                    )}{" "}
                                  </Grid>
                                )}
                              </Grid>
                            ) : (
                              <Grid container spacing={1}>
                                <Grid item xs={10}>
                                  <Field
                                    placeholder={t("type_question")}
                                    msgError={errors.title}
                                    name={translate("title")}
                                    isError={touched.title && errors.title}
                                    render={(props) => (
                                      <CustomInputComponent
                                        {...props}
                                        questionSeleted={questionSeleted}
                                        cancelBrowseQuestion={
                                          setQuestionSelected
                                        }
                                        setFieldValue={setFieldValue}
                                        values={values}
                                        lang={lang}
                                      />
                                    )}
                                    type="text"
                                  />
                                </Grid>

                                <Grid item xs={2}>
                                  <Button
                                    variant="contained"
                                    color="button"
                                    fullWidth
                                    sx={{ height: "40px" }}
                                    onClick={() => {
                                      setOpen(true);
                                    }}
                                  >
                                    <OpenInBrowserIcon />
                                    {t("browse_questions")}
                                  </Button>
                                </Grid>
                                {!questionSeleted && (
                                  <Grid item xs={12}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                      }}
                                    >
                                      <TranslateIcon sx={{ width: "16px" }} />
                                      <p
                                        style={{
                                          color: "#8D8482",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {t("error_translation_usecases")}{" "}
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "13px",
                                            textDecoration: "underline",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setOpenTranslator(true);
                                          }}
                                        >
                                          {t("here")}
                                        </span>
                                      </p>
                                    </div>
                                  </Grid>
                                )}
                              </Grid>
                            )}
                          </>
                        ) : (
                          <span>
                            {values[translate("title")] || t("not_specified")}
                          </span>
                        )}
                      </Grid>
                    </Grid>

                    <Divider />
                    <Grid container spacing={1} sx={{ padding: "20px" }}>
                      <Grid item xs={12} marginBottom="20px">
                        <span style={{ color: "grey", fontWeight: 600 }}>
                          {t("answers")}
                        </span>
                      </Grid>

                      <FieldArray name="choices">
                        {() =>
                          values?.choices?.map((ticket, i) => {
                            const ticketErrors =
                              (errors.choices?.length && errors.choices[i]) ||
                              {};
                            const ticketTouched =
                              (touched.choices?.length && touched.choices[i]) ||
                              {};
                            return (
                              <Grid
                                container
                                spacing={isMobile ? 2 : 7}
                                sx={{
                                  padding: "5px",
                                  fontSize: isMobile ? "12px" : "15px",
                                }}
                                key={i}
                                wrap={"wrap"}
                              >
                                {isEditMode && !isDisplayMode ? (
                                  <>
                                    <Grid item xs={!isMobile ? 10 : 16}>
                                      <Field
                                        placeholder={t("type_answer")}
                                        msgError={
                                          ticketErrors[translate("title")]
                                        }
                                        name={`choices.${i}.${[
                                          translate("title"),
                                        ]}`}
                                        isError={
                                          ticketErrors[translate("title")] &&
                                          ticketTouched[translate("title")]
                                        }
                                        component={CustomInputComponent}
                                        type="text"
                                      />
                                    </Grid>

                                    <Grid item xs={!isMobile ? 2 : 15}>
                                      <div style={{ display: "flex" }}>
                                        <Field
                                          placeholder="Points"
                                          msgError={ticketErrors?.weight}
                                          name={`choices.${i}.weight`}
                                          isError={
                                            ticketErrors.weight &&
                                            ticketTouched.weight
                                          }
                                          component={CustomInputComponent}
                                          type="number"
                                          threshold={threshold}
                                        />
                                        <IconButton
                                          disabled={values.choices.length < 3}
                                          sx={{ height: 40, width: 40 }}
                                          onClick={() =>
                                            deleteAnswer(i, values, setValues)
                                          }
                                        >
                                          <DeleteForeverOutlinedIcon />
                                        </IconButton>
                                      </div>
                                      {isMobile && <hr />}
                                    </Grid>
                                  </>
                                ) : (
                                  <Grid item xs={12}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span>{ticket[translate("title")]}</span>
                                      <PointCard value={ticket.weight} />
                                    </div>
                                  </Grid>
                                )}
                              </Grid>
                            );
                          })
                        }
                      </FieldArray>
                    </Grid>
                    {isEditMode && !isDisplayMode && (
                      <>
                        <div style={{ padding: "0px 20px" }}>
                          <Button
                            // variant="contained"
                            size="small"
                            sx={{
                              background: "#F2F2F2",
                              color: "#000000",
                              width: isMobile ? "100%" : {},
                            }}
                            onClick={() => addtitle(values, setValues)}
                          >
                            <AddOutlinedIcon />
                            {t("add_answer")}
                          </Button>
                        </div>
                        <div
                          style={{
                            padding: "10px 20px",
                            textAlign: "end",
                            display: isMobile ? "flex" : {},
                          }}
                        >
                          <Button
                            onClick={() => {
                              cancelQuestion(resetForm);
                              setIsEditMode(false);
                            }}
                            size="small"
                            color="primary"
                            variant="outlined"
                            style={{
                              marginRight: "10px",
                              width: isMobile ? "50%" : {},
                            }}
                          >
                            {t("cancel")}
                          </Button>
                          <Button
                            size="small"
                            type="submit"
                            color="secondary"
                            variant="contained"
                            startIcon={<SaveAsOutlinedIcon />}
                            style={{
                              marginRight: "10px",
                              width: isMobile ? "50%" : {},
                            }}
                          >
                            {t("save")}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                  <BrowseQuestion
                    open={open}
                    handleClose={handleClose}
                    setFiledValue={setFieldValue}
                    values={values}
                    handleQuestionSelected={handleQuestionSelected}
                    lang={lang}
                  />
                  <TranslationModal
                    open={openTranslator}
                    handleClose={handleCloseTranslator}
                    index={index}
                    threshold={threshold}
                    deleteAnswer={deleteAnswer}
                    setFieldValue={setFieldValue}
                    values={values}
                    lang={lang}
                  />
                </Form>
              )}
            </Formik>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default QuestionChoicesCard;
